export default __webpack_public_path__ + "assets/zoom.87316a14.svg";